import React from "react";
import { Combobox as BaseCombobox } from "../../../ui/combobox";
import { ComboboxProps } from "../types";
import { withFormField } from "./withFormField";

const BaseComboboxComponent = React.forwardRef<
  React.ComponentRef<typeof BaseCombobox>,
  ComboboxProps
>((props, ref) => {
  const {
    options = [],
    onChange = () => {},
    searchPlaceholder,
    onSearchChange,
    ...rest
  } = props;

  const onValueChange = (newValue: string) => {
    onChange({
      target: { value: newValue },
    } as React.ChangeEvent<HTMLInputElement>);
  };

  return (
    <BaseCombobox
      ref={ref}
      options={options}
      onValueChange={onValueChange}
      searchPlaceholder={searchPlaceholder}
      onSearchChange={onSearchChange}
      {...rest}
    />
  );
});

export const Combobox = withFormField<ComboboxProps>(BaseComboboxComponent);
